import { UploadFileContext } from '@/App'
import { Button, message } from 'antd'
import { RcFile } from 'antd/lib/upload'
import { useCallback, useContext, useEffect, useState } from 'react'
import './index.less'
import UploadFilePanelItem from './upload-item'
import DragModal from '@/baseui/drag-modal/DragModal'

export interface UploadFileLocale {
    file: RcFile,
    callbackFn: (param: FileUploadParam) => Promise<any>
    bucketName?: string
}

export interface UploadFileState {
    files: UploadFileLocale[]
    visible: boolean
    startUpload: (files: UploadFileLocale[], bucketName?: string) => void
    onEnd: (value: number) => void
    count: number // 用于记录上传了多少个文件
    bucketName?: string
}

export interface FileUploadParam {

    md5: string,
    suffix: string,
    filePath: string,
    name: string,
    type?: number,
    replaceId?: number,
    parentId?: number,
    fileSize: number,

}

export const useUploadService = () => {
    const [files, setFiles] = useState<UploadFileLocale[]>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const startUpload = useCallback((uploadFiles: UploadFileLocale[]) => {
        setCount(0);
        setFiles(uploadFiles)
    }, [])

    const onEnd = useCallback((value: number) => {
        setCount(value);
        setVisible(false)
    }, [])

    useEffect(() => {
        if (files.length > 0) {
            setVisible(true);
        }
    }, [files])

    return {
        files,
        visible,
        startUpload,
        onEnd,
        count,
    } as UploadFileState
}

export default function UploadPanel(props) {
    const uploadContext = useContext<UploadFileState>(UploadFileContext);
    const [files, setFiles] = useState<UploadFileLocale[]>([]);
    const [uploadCounter, setUploadCounter] = useState(0);
    const [stopSignal, setStopSignal] = useState(false);

    useEffect(() => {
        if (uploadContext.visible) {
            setStopSignal(false)
            start();
        }
    }, [uploadContext.visible])

    useEffect(() => {
        if (uploadCounter && uploadCounter === files.length) {
            onClose();
        }
    }, [uploadCounter])

    const start = () => {
        let files = uploadContext.files;
        if (files == null || files.length === 0) {
            message.warning('没有要上传的文件，上传被取消');
            onClose();
            return;
        }
        setFiles([...files]);
    }

    const onClose = (time = 500) => {
        setTimeout(() => {
            setFiles([]);
            uploadContext.onEnd(uploadCounter);
            setUploadCounter(0);
        }, time)
    }

    const stop = () => {
        setStopSignal(true)
        onClose(0);
    }

    return (
        <DragModal
            visible={uploadContext.visible}
            mask
            showHeader={false}
            destroyOnClose={true}
        >
            <div className="upload-panel-container">
                <div className='scrollable'>
                    {files.map(item => (
                        <UploadFilePanelItem
                            onComplete={() => setUploadCounter(pre => pre + 1)}
                            key={item.file.uid}
                            file={item.file}
                            stopSignal={stopSignal}
                            bucketName={item.bucketName}
                            callbackFn={item.callbackFn} />
                    ))}
                </div>

                <div className="footer">
                    <Button danger size="small" onClick={stop}>取消上传</Button>
                </div>
            </div>
        </DragModal>
    )
}